'use strict'

/**
 *
 * @name: addonVimeo
 *
 */

import DirectiveTemplate from './nn-addon-vimeo.directive.html'
import './nn-addon-vimeo.directive.scss'

function AddonVimeoDirective($sce) {

  'ngInject'

  return {
    restrict: 'C',
    replace: true,
    scope: {
      post: '=*',
    },
    template: DirectiveTemplate,
    controller: function($scope, $attrs, $http) {
      'ngInject'; // jshint ignore:line

      /*
       *
       * @CONFIG
       *
       */


      $scope.vimeoSettings = {
        item: null,
        src: null
      }
      $scope.videoId = null
      $scope.aspectRatio = ''


      /*
       *
       * @PUBLIC
       *
       */


      /*
       *
       * @PRIVATE
       *
       */


      function _init () {
        $scope.post.media.some(function(item) {

          if (item.key === $attrs.mediaKey) {
            $scope.vimeoSettings.item = item
            $scope.videoId = item.content
            $scope.vimeoSettings.src = $sce.trustAsResourceUrl('//player.vimeo.com/video/' + $scope.videoId)

            $http.get('https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + $scope.videoId).then((res) => {
              const { data: { width, height } } = res
              $scope.aspectRatio = height / width * 100 + '%'
            })

            return true
          }

          return false
        })
      }


      /*
       *
       * @INIT
       *
       */


      _init()


    }
  }
}

export default AddonVimeoDirective



// WEBPACK FOOTER //
// ./app/components/nn-add-ons/nn-addon-vimeo/nn-addon-vimeo.directive.js